import React from "react";
import { List } from "../modules/Settings/Tests";

export function SettingsTestsListPage() {
  return <List />;
}
